import { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, useParams } from "react-router-dom"
import { SideHeader, ContextMenu, MenuList, MenuItem, TnModal, Dropdown, Modal, Input, LeftSideList } from 'bimui';
import "./index.less";
import { Image, Skeleton, message } from "antd";
import { createProjectMaterial, deleteProjectMaterialMulti, findProjectMaterials } from '@/declare/api/project/project-material';
import { ReactComponent as AddSvg } from '../icons/add.svg';
import { findMaterialCategoryList, findMaterialCodeList } from '@/declare/api/system-lib/material';
import { MaterialCategory, MaterialCode, MaterialMark, PMaterial } from '@/declare/interface/project/material';
import { ReactComponent as Add32Svg } from 'bimui/dist/c1/icons/new-default_32.svg';
import { ReactComponent as UnSelectSvg } from './icons/un-select.svg';
import { ReactComponent as SelectSvg } from './icons/select.svg';
import { ReactComponent as RightArrowSvg } from './icons/right-arrow.svg';
import { ReactComponent as BoxSelectSvg } from './icons/box-select.svg';
import { ReactComponent as BoxSvg } from './icons/box.svg';
import classNames from 'classnames';
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import { generateUUID } from 'three/src/math/MathUtils';
import localStore from '@/store/local-store';
import { SIDEBAR_TYPE } from '@/declare/enums/menu-type';


export default function MaterialPanelComponent() {
    const routeParams = useParams();
    // 获取当前项目ID
    const { projectUuid } = useParams();
    const navigate = useNavigate();
    // 页面loading
    const [loading, setLoading] = useState<boolean>(false);

    // 材料标准
    const [materialCodeList, setMaterialCodeList] = useState<MaterialCode[]>([]);
    const [materialCodeOptions, setMaterialCodeOptions] = useState([]); // 材料标准下拉选项
    const [materialCategoryList, setMaterialCategoryList] = useState<MaterialCategory[]>([]); // 材料分类
    const [selectedMaterialCategoryId, setSelectedMaterialCategoryId] = useState<number>(); // 选中的材料分类
    const [selectedMaterialCode, setSelectedMaterialCode] = useState(null); // 选中的材料标准
    const [projectMarkList, setProjectMarkList] = useState<MaterialMark[]>([]); // 项目材料列表
    const [displayMarkList, setDisplayMarkList] = useState<MaterialMark[]>([]); // 展示的材料列表
    const [selectedMaterialMarkIds, setSelectedMaterialMarkIds] = useState<string[]>([]); // 选中的材料标记
    const dbClickRef = useRef(false); // 双击标记

    const [modalSelectedMarkIds, setModalSelectedMarkIds] = useState<string[]>([]); // 添加弹窗选中的材料标记
    const [modalSelectedCode, setModalSelectedCode] = useState<MaterialCode>(null); // 添加弹窗选中的材料标准
    const [modalSelectedCategory, setModalSelectedCategory] = useState(null); // 添加弹窗选中的材料分类
    const [categoryList, setCategoryList] = useState<MaterialCategory[]>([]); // 完整材料分类列表

    const [modalInputValue, setModalInputValue] = useState(""); // 添加弹窗输入框的值

    const [eventDelUuid, setEventDelUuid] = useState(null); // 删除事件的uuid
    const [lastClickIdx, setLastClickIdx] = useState<number>(null); // 上一次点击的索引
    const [activeMarkId, setActiveMarkId] = useState<string>(); // 打开详情的材料
    /**
     * 控制添加添加弹窗的显示状态
     */
    const [showAddModal, setShowAddModal] = useState<boolean>(false);
    // 右键菜单
    const [rtxVisible, setRtxVisible] = useState<boolean>(false);
    const [rtxTop, setRtxTop] = useState<number>();
    const [rtxLeft, setRtxLeft] = useState<number>();

    useEffect(() => {
        let status = localStore.getSidebarStatus(SIDEBAR_TYPE.MATERIAL);
        setSelectedMaterialMarkIds(status['selectedMaterialMarkIds'] || []);
        console.log('status[selectedMaterialMarkIds]', status['selectedMaterialMarkIds'])
        setSelectedMaterialCategoryId(status['selectedMaterialCategoryId']);
        // 获取本项目的所有材料，并将对应类型的材料返回到列表中
        generateData(status['selectedMaterialCategoryId'])
    }, [])

    const updateStatus = (selectedMaterialMarkIds: any, selectedMaterialCategoryId: number) => {
        // 在这里向外传递状态
        let status = {
            selectedMaterialMarkIds: selectedMaterialMarkIds,
            selectedMaterialCategoryId: selectedMaterialCategoryId,
        };
        localStore.setSidebarStatus(SIDEBAR_TYPE.MATERIAL, status);
    }

    useEffect(() => {
        if (!routeParams) return;
        let url = routeParams['*'];
        let markId = url.split("material-marks/")[1];
        if (!markId) return;
        setActiveMarkId(markId);
    }, [routeParams])

    useEffect(() => {
        // emitter.on(Emit_Event_Common_Tool.COPY, handleCopy);
        emitter.on(Emit_Event_Common_Tool.DELETE, onClickMenuDelete);
        // emitter.on(Emit_Event_Common_Tool.EDIT, handleEdit);

        return () => {
            // emitter.off(Emit_Event_Common_Tool.COPY, handleCopy);
            emitter.off(Emit_Event_Common_Tool.DELETE, onClickMenuDelete);
            // emitter.off(Emit_Event_Common_Tool.EDIT, handleEdit);
        }
    }, [])

    useEffect(() => {
        if (eventDelUuid != null) {
            handleDelete();
        }
    }, [eventDelUuid])

    useEffect(() => {
        const options = [];
        materialCodeList.forEach(item => {
            options.push({ label: item.code, value: item.id, category: item.category });
        })
        // if (materialCodeList != null && materialCodeList.length > 0) {
        //     setSelectedMaterialCode(materialCodeList[0].id);
        // } else {
        //     setSelectedMaterialCode(null);
        // }
        setMaterialCodeOptions(options);
    }, [materialCodeList])

    useEffect(() => {
        filterMark(projectMarkList);
    }, [projectMarkList, selectedMaterialCode, selectedMaterialCategoryId])


    const filterMark = (marks: MaterialMark[]) => {
        let newMarks = JSON.parse(JSON.stringify(marks));

        const code = materialCodeList.find(c => c.id === selectedMaterialCode);
        if (selectedMaterialCategoryId != null) {
            const str = selectedMaterialCategoryId.toString();
            newMarks = newMarks.filter(m => m.category === selectedMaterialCategoryId || m.category === str);
        }

        if (code != null) {
            if (code.code != "无") {
                newMarks = newMarks.filter(m => m.code === code.code);
            } else {
                newMarks = newMarks.filter(m => m.code == null);
            }
        }
        setDisplayMarkList([...newMarks]);
    }

    const generateData = (selectedCategoryId?: number) => {
        if (!projectUuid) {
            return;
        }
        setLoading(true);
        // findMaterialCodeList().then(res => {
        //     const list = res.data || [];
        //     list.push({ id: -1, code: '无', category: null })
        //     setMaterialCodeList(list);
        // }).catch(err => {
        //     message.error("获取材料标准编码错误");
        // })
        findProjectMaterials(projectUuid).then(res => {
            const projectMaterials = res.data || [];
            const categoryIds = new Set();
            const categoryList = [];
            const marks = [];
            const codes = [];

            let id = 1;
            projectMaterials.forEach(pm => {
                if (pm.mark != null) {
                    marks.push(pm.mark);
                    if (pm.mark.category != null) {
                        if (!categoryIds.has(pm.mark.category)) {
                            categoryIds.add(pm.mark.category);
                            const category: MaterialCategory = {
                                id: pm.mark.category,
                                name: pm.materialCategoryName,
                                iconUrl: pm.materialCategoryIconUrl
                            }
                            categoryList.push(category);
                        }

                        let code = pm.mark.code;
                        if (code == null) code = "无";
                        const idx = codes.findIndex(c => c.code === code && c.category === pm.mark.category);
                        if (idx === -1) {
                            codes.push({ id: id++, code: code, category: pm.mark.category });
                        }
                    }
                }
            })
            setMaterialCodeList(codes);
            // marks遍历，筛选掉id重复的数据
            const uniqueMarks = marks.filter((value, index, self) => {
                return self.indexOf(value) === index;
            })
            setProjectMarkList(uniqueMarks);
            setMaterialCategoryList([...categoryList]);
            // 找不到就设置
            let categoryId = selectedCategoryId;
            if (selectedCategoryId == null || categoryList.findIndex(c => c.id === selectedCategoryId) === -1) {
                if (categoryList.length > 0) {
                    categoryId = categoryList[0].id;
                    setSelectedMaterialCategoryId(categoryList[0].id);
                }
            }
            if (categoryId != null) {
                const num = Number(categoryId);
                const code = codes.find(i => i.category === categoryId || i.category === num);
                setSelectedMaterialCode(code?.id);
            }
        }).catch(err => {
            message.error("获取材料信息错误");
        }).finally(() => {
            setLoading(false);
        })
        findMaterialCategoryList(true).then(res => {
            setCategoryList(res.data || []);
        }).catch(err => {
            message.error("获取材料分类失败");
        })
    }

    // 删除事件
    const onClickMenuDelete = () => {
        setEventDelUuid(generateUUID());
    }

    // 删除操作
    const handleDelete = () => {
        if (selectedMaterialMarkIds == null || selectedMaterialMarkIds.length === 0 || loading) return;
        setLoading(true);
        TnModal().deleteModal({
            onOk() {
                deleteProjectMaterialMulti(projectUuid, selectedMaterialMarkIds).then(res => {
                    const newList = projectMarkList.filter(m => !selectedMaterialMarkIds.includes(m.id));
                    setProjectMarkList(newList);
                    // message.success("删除成功");
                }).catch(err => {
                    message.error("删除失败");
                }).finally(() => {
                    setLoading(false);
                    TnModal().destoryAll();
                })
            },
        })
    }

    // 点击项目材料mark行
    const onClickMarkRow = (e, row: MaterialMark, index: number) => {
        // 判断当前是否按住ctrl键
        const isCtrl = e.ctrlKey
        const isShift = e.shiftKey;
        dbClickRef.current = false;
        setTimeout(() => {
            if (!dbClickRef.current) {
                let markIds = selectedMaterialMarkIds;
                if (isCtrl) {
                    if (markIds.includes(row.id)) {
                        markIds = markIds.filter(m => m !== row.id);
                    } else {
                        markIds.push(row.id);
                    }
                } else if (isShift && lastClickIdx != null) {
                    const start = Math.min(index, lastClickIdx);
                    const end = Math.max(index, lastClickIdx);

                    for (let i = start; i <= end; i++) {
                        const mark = displayMarkList[i];
                        if (!markIds.includes(mark.id)) {
                            markIds.push(mark.id);
                        }
                    }
                } else {
                    if (markIds.includes(row.id)) {
                        markIds = [];
                    } else {
                        markIds = [row.id];
                    }
                }
                setLastClickIdx(index);
                setSelectedMaterialMarkIds([...markIds]);
                updateStatus([...markIds], selectedMaterialCategoryId);
            }
        }, 150)
    }

    // 双击项目材料mark行
    const onDbClickMarkRow = (row: MaterialMark) => {
        dbClickRef.current = true
        // TODO 打开详情页签
        navigate(`/projects/${projectUuid}/material-marks/${row.id}`);
    }

    // 点击保存
    const onModalSave = () => {
        if (modalSelectedMarkIds == null || modalSelectedMarkIds.length === 0) return;
        if (loading) return;
        setShowAddModal(false);
        setModalInputValue("");
        setModalSelectedMarkIds([]);
        setLoading(true);
        createProjectMaterial(projectUuid, modalSelectedMarkIds).then(res => {
            generateData();
        }).catch(err => {
            message.error("添加失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    // 点击取消
    const onModalCancel = () => {
        setShowAddModal(false);
        setModalInputValue("");
        setModalSelectedMarkIds([]);
    }

    // 点击添加材料
    const onClickAddMaterial = () => {
        setShowAddModal(true);
        setModalSelectedCategory(categoryList[0] || null);
        setModalSelectedCode(categoryList[0]?.codes[0] || null);
        // 遍历拿到已经添加到项目的mark集合
        const ids = [];
        projectMarkList.forEach(item => {
            ids.push(item.id);
        })
        setModalSelectedMarkIds([...ids]);
    }

    // 点击左侧分类
    const onClickLeftCategory = (categoryId) => {
        setSelectedMaterialCategoryId(categoryId);
        const num = Number(categoryId);
        const code = materialCodeList.find(i => i.category === categoryId || i.category === num);
        setSelectedMaterialCode(code?.id);
        setSelectedMaterialMarkIds([]);
        updateStatus([], categoryId)
    }

    return (
        <Skeleton loading={false} active>
            <div className="material-container">
                <Skeleton loading={false} active>
                    <div className="material-list">
                        <SideHeader>
                            <div className="header">
                                <span>材料</span>
                                <AddSvg className='add-icon' onClick={() => onClickAddMaterial()} />
                            </div>
                        </SideHeader>
                        <Dropdown options={materialCodeOptions.filter(item => {
                            return item.category == null || item.category === Number(selectedMaterialCategoryId)
                        })} value={selectedMaterialCode} style={{ width: '100%' }}
                            onChange={(value) => setSelectedMaterialCode(value)} />
                        <LeftSideList
                            leftItems={materialCategoryList}
                            uniqueKey="id"
                            activeLeftItemKey={selectedMaterialCategoryId}
                            onClickLeftItem={(e, category) => onClickLeftCategory(category.id)}
                            leftItemContainer={({ leftItem }) => {
                                return (
                                    <>
                                        {!!leftItem.iconUrl && <Image width={48} height={48} preview={false} src={leftItem.iconUrl} />}
                                        <div className='category-name ellipsis'>{leftItem.name}</div>
                                    </>
                                );
                            }}
                            activeAddSvg={<Add32Svg className='active' />}
                        >
                            <div className='material-item-list'>
                                {displayMarkList?.map((mark, index) => {
                                    return (
                                        <div className={classNames({
                                            'material-row': true,
                                            'active': selectedMaterialMarkIds.includes(mark.id) || activeMarkId == mark.id
                                            // 'active': activeMarkId == mark.id
                                        })} onClick={(e) => onClickMarkRow(e, mark, index)}
                                            onDoubleClick={() => onDbClickMarkRow(mark)}
                                            onContextMenu={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                if (!selectedMaterialMarkIds.includes(mark.id)) {
                                                    selectedMaterialMarkIds.push(mark.id);
                                                }
                                                setRtxLeft(e.clientX);
                                                setRtxTop(e.clientY);
                                                setRtxVisible(true);
                                            }}>
                                            {/* <span className={classNames({
                                                'material-bar': true,
                                                'active': selectedMaterialMarkIds.includes(mark.id)
                                            })}>
                                                <SelectSvg className='select-svg' />
                                                <UnSelectSvg className='un-select-svg' />
                                            </span> */}
                                            <span className='material-no'>{String(index + 1).padStart(3, '0')}</span>
                                            <span className='material-mark ellipsis'>{mark?.mark}</span>
                                        </div>
                                    )
                                })}
                            </div>
                        </LeftSideList>
                    </div>
                </Skeleton>
            </div>

            <ContextMenu visible={rtxVisible} left={rtxLeft} top={rtxTop} onCancel={() => { setRtxVisible(false); }}
                wrapperClassname='position-rtx'>
                <MenuList>
                    <MenuItem onClick={() => {
                        const lastMarkId = selectedMaterialMarkIds[selectedMaterialMarkIds.length - 1];
                        const row = projectMarkList.find(m => m.id === lastMarkId);
                        setRtxVisible(false);
                        if (!row) return;
                        onDbClickMarkRow(row);
                    }}>查看详情</MenuItem>
                    <MenuItem onClick={() => {
                        setRtxVisible(false);
                        handleDelete();
                    }}>删除材料</MenuItem>
                </MenuList>
            </ContextMenu>

            <Modal
                open={showAddModal}
                width={459}
                mask={true}
                loading={loading}
                title='材料系统库'
                onSave={onModalSave}
                onCancel={onModalCancel}
                wrapClassName='material-modal-container'
            >
                <div className='material-modal-header'>
                    <Dropdown options={modalSelectedCategory?.codes?.map(code => {
                        return { label: code.code, value: code.code }
                    }) || []} value={modalSelectedCode?.code} onChange={(value) => {
                        const code = modalSelectedCategory.codes.find(c => c.code === value);
                        setModalSelectedCode(code);
                    }} />
                    <Input value={modalInputValue} onChange={(e) => setModalInputValue(e.target.value)} />
                </div>
                <div className='material-modal-body'>
                    <div className='body-left'>
                        {categoryList.map(category => {
                            return <div className={classNames({
                                'category-item': true,
                                'active': modalSelectedCategory?.id === category.id
                            })} key={category.id} onClick={() => {
                                setModalSelectedCategory(category);
                                setModalSelectedCode(category?.codes[0] || null);
                            }}>
                                <span>{category.name}</span>
                                <RightArrowSvg className='icon' />
                            </div>
                        })}
                    </div>
                    <div className='body-right'>
                        {modalSelectedCode?.marks?.filter(mark => {
                            if (modalInputValue == null || modalInputValue === '') {
                                return true;
                            }
                            return mark.mark.includes(modalInputValue);
                        })?.map(mark => {
                            return (
                                <div className={classNames({
                                    'mark-item': true,
                                    'active': modalSelectedMarkIds.includes(mark.id)
                                })} key={mark.id} onClick={() => {
                                    const idx = modalSelectedMarkIds.indexOf(mark.id);
                                    if (idx > -1) {
                                        modalSelectedMarkIds.splice(idx, 1);
                                    } else {
                                        modalSelectedMarkIds.push(mark.id);
                                    }
                                    setModalSelectedMarkIds([...modalSelectedMarkIds]);
                                }}>
                                    <BoxSvg className='box-icon' />
                                    <BoxSelectSvg className='box-select-icon' />
                                    <span className='mark-name ellipsis'>{mark.mark}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Modal>

        </Skeleton>
    );
}